import DashboardFTUEModal from './DashboardFTUEModal';

export default DashboardFTUEModal;